export default __webpack_public_path__ + "static/media/Ballroll_00227.0ad79166.png";